export const isDocumentRtl = () => document.dir === "rtl";
